// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadOrderStatusMappings from "@insite/client-framework/Store/Data/OrderStatusMappings/Handlers/LoadOrderStatusMappings";
import { getOrderStatusMappingDataView } from "@insite/client-framework/Store/Data/OrderStatusMappings/OrderStatusMappingsSelectors";
import { OrderStatusMappingModel } from "@insite/client-framework/Types/ApiModels";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import InfosBox, { InfosBoxStyles, InfosBoxType } from "@store/Library/Components/Toolkit/InfosBox";
import Typography from "@store/MobiusOverrides/Typography/Typography";
import React from "react";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

interface Props {
    status: string;
    erpStatus?: string;
    // Store Custom Code - accept qty to display
    qty?: number;
}

export interface StoreOrderStatusStyles {
    infosBox?: InfosBoxStyles;
    statusText?: TypographyProps;
    statusTextWrapper?: InjectableCss;
}

export const storeOrderStatusStyles: StoreOrderStatusStyles = {
    // Store Custom Code - >
    infosBox: {
        wrapper: {
            css: css`
                width: fit-content;
                padding: 0.375rem;
            `,
        },
        // Store Custom Code - <----
    },
    statusText: {
        css: css`
            width: 100%;
            text-align: center;
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        `,
    },
};

const styles = storeOrderStatusStyles;

interface OrderStatusMappings {
    value?: OrderStatusMappingModel[];
    properties: Record<string, string>;
    isLoading?: boolean;
    pagination?: Record<string, string>;
}
let hasCalled = false;
// Store Custom Code - accept qty to display
const OrderStatus: FC<Props> = ({ status, qty }) => {
    // bunzl deleted code - removed useState as its just derived from mapped status.
    const dispatch = useAppDispatch();
    const orderStatusMappings = useSelector((state: ApplicationState) =>
        getOrderStatusMappingDataView(state),
    ) as OrderStatusMappings;
    let orderStatusMappingsFromSystemList: Record<string, InfosBoxType> = {};
    if (orderStatusMappings.properties?.types) {
        orderStatusMappingsFromSystemList = JSON.parse(orderStatusMappings.properties?.types) as Record<
            string,
            InfosBoxType
        >;
    }
    useEffect(() => {
        // Store Custom Code - added check to see if orderStatusMappings.value is empty to avoid extra api calls.
        if (!orderStatusMappings.value?.length && !orderStatusMappings.isLoading) {
            if (hasCalled) {
                return;
            }
            hasCalled = true;
            dispatch(loadOrderStatusMappings());
        }
    }, [dispatch, orderStatusMappings.isLoading, orderStatusMappings.value?.length]);

    // Store Custom Code - deleted useEffect
    const statusToUse = orderStatusMappingsFromSystemList[status] || "default";
    if (!status) {
        return null;
    }

    // Store Custom Code - accept qty to display
    const qtyText = qty ? ` (${qty})` : "";
    return (
        <InfosBox size="tiny" type={statusToUse} showIcon={false} extendedStyles={styles.infosBox}>
            <Typography {...styles.statusText}>
                {status}
                {qtyText} {/* Store Custom Code - accept qty to display */}
            </Typography>
        </InfosBox>
    );
};

export default OrderStatus;
